'BundleList'.list()
'Bundles'.title()
'Back'.action({act: 'cancel'})
'Add'.action({act: 'add'})
'Refresh'.action({act: "refresh"})
'Download to Excel'.action({act: 'excel'})
'BundleMaint.js'.maintSpecname()

'Bundle'.datatype()
'bundleNumber'.field()
'product'.field()
'overheadCost'.field()
'totalCost'.field()
'quantityPickable'.field()
'quantityMakeable'.field()
'quantityReservedForCustomerOrders'.field()
'sellableQuantity'.field()
'Edit'.action({place: 'row', act: 'edit'})
'Trash'.action({place: 'row', act: 'trash'})
'BundleMaint.js'.maintSpecname()

'BundleList'.beforeLoading(async list => {
  await list.harmonize()
})
